module.exports = __webpack_public_path__ + "static/contact-address-f37ff4562771af036ad063800657bd05.svg";